// Tours quoted on WhatsApp (no payment on the site): price unit, booking panel and the quote dialog.
export default {
  quote: {
    title: 'Pide tu cotización',
    unit: { boat: 'por la lancha completa', schooner: 'por el barco completo', group: 'por el grupo' },
    calendarPrice: { boat: '{{price}} por la lancha completa', schooner: '{{price}} por el barco completo', group: '{{price}} por el grupo' },
    priceLine: { boat: 'Lancha completa', schooner: 'Barco completo', group: 'Grupo privado' },
    peopleTitle: 'Cuántas personas',
    people: 'Personas',
    peopleHint: 'Todos los que van al paseo',
    estimate: 'Valor de referencia',
    badge: 'Cotización por WhatsApp',
    note: 'Sin pago en el sitio: elige la fecha y cuántas personas van, y nuestro equipo te responde por WhatsApp si está disponible.',
    ask: 'Pedir cotización por WhatsApp',
    askShort: 'Pedir cotización',
    secure: 'Sin pago en el sitio: nuestro equipo responde tu cotización por WhatsApp.',
    count_one: '{{count}} persona',
    count_other: '{{count}} personas',
    adults_one: '{{count}} adulto',
    adults_other: '{{count}} adultos',
    children_one: '{{count}} niño',
    children_other: '{{count}} niños',
    babies_one: '{{count}} bebé',
    babies_other: '{{count}} bebés',
    modal: {
      title: 'Pedir cotización',
      lead: 'Escribe tu nombre: WhatsApp se abre con el pedido listo, solo tienes que enviarlo.',
      tour: 'Paseo',
      date: 'Fecha',
      people: 'Personas',
      name: 'Nombre completo',
      namePlaceholder: 'Nombre y apellido',
      nameError: 'Escribe tu nombre completo.',
      send: 'Enviar por WhatsApp',
      hint: 'Nuestro equipo te responde por WhatsApp si la fecha está disponible.',
      close: 'Cerrar',
      sentTitle: 'Pedido listo en WhatsApp',
      sentText: 'Envía el mensaje en WhatsApp. Nuestro equipo te responde si la fecha está disponible.',
      again: 'Abrir WhatsApp otra vez',
      done: 'Listo',
    },
  },
};
